function getCookieValue(cookieHeader: string, name: string): string | undefined {
    const match = cookieHeader.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`))
    return match ? decodeURIComponent(match[1]) : undefined
}

function getUserTokenFromGa(gaCookie: string): string | undefined {
    const parts = gaCookie.split('.').slice(-2)
    if (parts.length === 2) return parts.join('-')
    return undefined
}

function getUserTokenFromAlgoliaCookie(value: string): string | undefined {
    try {
        const parsed = JSON.parse(value) as { userToken?: string }
        if (parsed.userToken) return parsed.userToken
    } catch {
        // Cookie may already be the token string.
    }

    return value || undefined
}

function getUserTokenFromCookieHeader(cookieHeader: string | undefined | null): string | undefined {
    if (!cookieHeader) return undefined

    const algoliaCookie = getCookieValue(cookieHeader, '_ALGOLIA')
    if (algoliaCookie) {
        const token = getUserTokenFromAlgoliaCookie(algoliaCookie)
        if (token) return token
    }

    const gaCookie = getCookieValue(cookieHeader, '_ga')
    if (gaCookie) {
        const token = getUserTokenFromGa(gaCookie)
        if (token) return token
    }

    return undefined
}

export function getAlgoliaUserToken(req: Request): string | undefined {
    return getUserTokenFromCookieHeader(req.headers.get('cookie'))
}

export function getAlgoliaUserTokenFromDocument(): string | undefined {
    if (typeof document === 'undefined') return undefined
    return getUserTokenFromCookieHeader(document.cookie)
}
